import { Component } from 'react'
import { Box, Link, Heading } from 'theme-ui'

import emoji from 'react-easy-emoji'

class Header extends Component {
  render() {
    return (
      <Box 
        sx={{ 
          mt: [2, null, 3],
          backgroundColor: '#f5f5f5',
          padding: [3, null, 4],
          borderRadius: 2,
          border: '1px solid #e0e0e0'
        }}
      >
        <Box sx={{ mb: [2, null, 3], maxWidth: '40em', fontSize: [1, null, 2] }}>
          Polis-modellen er udviklet af <a href="https://compdemocracy.org/" target="_blank" rel="noopener noreferrer">The Computational Democracy Project</a>
          <br />
          Hjemmesiden og servere ejes af Dansk Kommunikation ApS.
          <br />
          Modellen kan lånes, hvis vi synes, at det tjener et almennyttigt formål. Kontakt: Dansk Kommunikation dakom@dakom.dk
        </Box>
        <Box sx={{ mb: [2, null, 3] }}>
          © Dansk Kommunikation - 
          <a href="https://dansksamtale.dk/privacy">Privatlivspolitik</a>
        </Box>
      </Box>
    )
  }
}

export default Header
